module.exports = __webpack_public_path__ + "img/partyworkbg.d429e7ca.png";